import React, { useContext } from "react";
import * as i18n from "util/i18n";
import { shape, string } from "prop-types";
import { TransactionInfo } from "pages/_components/TransactionCard";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";

const CheckbookSummary = ({ title, ...props }) => {
    const { transaction = {} } = useContext(TransactionContext);
    const { data = {} } = transaction;

    const {
        checksAccountSelected = props.checksAccountSelected,
        checksPerCheckbook = props.checksPerCheckbook,
        checkbookAmount = props.checkbookAmount,
        retrieverId = props.retrieverId,
        firstName = props.firstName,
        lastName = props.lastName,
    } = data;

    return (
        <div className="ticket__body checkbook-new" style={props.style}>
            {/* <div className="ticket-header-info">test</div> */}

            <TransactionInfo withoutSpace field="checks.control.account" value={checksAccountSelected?.label} />
            <TransactionInfo withoutSpace field="checks.control.checkQuantity" value={checksPerCheckbook} />
            <TransactionInfo field="checks.control.quantity" value={checkbookAmount} />
            <div className="data-wrapper my-8">
                <span className="data-label">{i18n.get("checks.control.autorization")}</span>
            </div>
            <TransactionInfo
                withoutSpace
                field="checks.control.document"
                value={`${retrieverId?.type} ${retrieverId?.code}`}
            />
            <TransactionInfo withoutSpace field="checks.control.name" value={firstName} />
            <TransactionInfo field="checks.control.lastName" value={lastName} />
            <TransactionInfo
                field="checks.control.deliveryPoint"
                value="Tek BNK - Casa Central - Av Madero 1020, CABA - Lunes a Viernes de 10:00 a 15:00 hs"
            />
        </div>
    );
};

CheckbookSummary.propTypes = {
    title: string,
    account: string,
    checksPerCheckbook: string,
    checkbookAmount: string,
    document: string,
    firstName: string,
    lastName: string,
    checksAccountSelected: shape({}),
    retrieverId: shape({}),
    style: shape({}),
};

CheckbookSummary.defaultProps = {
    title: "N/A",
    account: "N/A",
    checksPerCheckbook: "N/A",
    checkbookAmount: "N/A",
    document: "N/A",
    firstName: "N/A",
    lastName: "N/A",
    checksAccountSelected: null,
    retrieverId: null,
    style: null,
};

export default CheckbookSummary;
